import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EditView } from 'components/Crud';
import { jobTypeDomain, skillDomain, timeBandDomain } from 'models';
import { getDomainSlice, RootState } from 'store';
import { DomainItem } from 'models/Domain';
import { mapResponseDataToField } from 'components/Forms/utils/dataMap';
import JobType from 'models/JobTypes';
import { mergeErrors } from 'utils';
import { useSkillsState } from 'store/selectors';
import { getJobTypeInputFieldsProps, validationSchema } from './FormConfig';
import { processFormFields } from './utils';

const processJobTypeData = (item: DomainItem) => {
  return mapResponseDataToField(
    {
      requiredSkills: (jobType: JobType) => jobType.requiredSkills,
      timeBand: (jobType: JobType) => jobType.timeBand.id
    },
    item as JobType
  );
};

const EditJobTypeView = () => {
  const dispatch = useDispatch();

  const { actions: skillActions } = getDomainSlice(skillDomain);
  const {
    items: skillsData,
    isLoading: skillsDataIsLoading,
    error: skillsError
  } = useSkillsState();

  const {
    selector: timeBandSelector,
    actions: timeBandActions
  } = getDomainSlice(timeBandDomain);
  const {
    items: timeBandData,
    isLoading: timeBandDataIsLoading,
    error: timeBandError
  } = useSelector<RootState, ReturnType<typeof timeBandSelector>>(
    timeBandSelector
  );

  // TODO - temporary high page size values until FFT-612 is completed
  useEffect(() => {
    if (skillActions.changePagination) {
      dispatch(
        skillActions.changePagination({ pageIndex: 0, pageSize: 10000 })
      );
    }
    if (timeBandActions.changePagination) {
      dispatch(
        timeBandActions.changePagination({ pageIndex: 0, pageSize: 10000 })
      );
    }
  }, []);

  const isLoading = skillsDataIsLoading || timeBandDataIsLoading;
  const error = mergeErrors([skillsError, timeBandError]);

  return (
    <EditView
      domain={jobTypeDomain}
      fields={getJobTypeInputFieldsProps('edit', skillsData, timeBandData)}
      validationSchema={validationSchema}
      title="Edit job type"
      presubmitCallback={processFormFields}
      processDomainData={processJobTypeData}
      loading={isLoading}
      error={error}
    />
  );
};

export default EditJobTypeView;
